import Vue from 'vue'
import App from './App.vue'
import router from './router'

import Buefy from 'buefy'
Vue.use(Buefy);

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios);

Vue.config.productionTip = false;

Vue.prototype.$host = "https://sequdocqueue-reliable-mandrill-xb.au-syd.mybluemix.net/api";
Vue.prototype.$domain = "https://sequdocqueue-reliable-mandrill-xb.au-syd.mybluemix.net";

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
